import { render, staticRenderFns } from "./InspectionHomeworkManagement.vue?vue&type=template&id=92bddbd0&scoped=true"
import script from "./InspectionHomeworkManagement.vue?vue&type=script&lang=js"
export * from "./InspectionHomeworkManagement.vue?vue&type=script&lang=js"
import style0 from "./InspectionHomeworkManagement.vue?vue&type=style&index=0&id=92bddbd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92bddbd0",
  null
  
)

export default component.exports